// @ts-nocheck
/* eslint-disable */
export const boldArrowDownNoBoxIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M11.947 5.453H4.053c-.64 0-.96.774-.506 1.227L7 10.134a1.42 1.42 0 0 0 2.007 0L10.32 8.82l2.14-2.14a.721.721 0 0 0-.513-1.227"/></svg>`,
    name: 'bold-arrow-down-no-box' as const
};